export default __webpack_public_path__ + "static/media/trr-food-smallplate-parfaitbowl.66375b73.png";